import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleLeft,
  faAnglesLeft,
  faAngleRight,
  faAnglesRight,
  faAngleDown,
  faAngleUp,
  faImages,
  faUsers,
  faFlag,
  faRobot,
  faCogs,
  faCog,
  faSearch,
  faTrash,
  faExclamationTriangle,
  faCheck,
  faCheckCircle,
  faTimes,
  faNotesMedical,
  faCalendarMinus,
  faThumbsDown,
  faExclamation,
  faQrcode,
  faPencilAlt,
  faStickyNote,
  faFileDownload,
  faExclamationCircle,
  faFile,
  faFileExport,
  faUser,
  faPhone,
  faEnvelope,
  faArrowUpRightFromSquare,
  faBook,
  faFileExcel,
  faXmarkCircle,
  faFileCircleCheck,
  faCircleQuestion,
  faFilePdf,
  faPlayCircle,
  faPrint,
  faPaperclip,
  faBars,
  faCaretDown,
  faComment,
  faMinusCircle,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";

/**
 * Initializes the FontAwesome library with all commonly used icons.
 * This should be called once at application startup.
 */
export const initializeSharedIcons = (): void => {
  library.add(
    faAngleLeft,
    faAnglesLeft,
    faAngleRight,
    faAnglesRight,
    faAngleDown,
    faAngleUp,
    faImages,
    faUsers,
    faFlag,
    faRobot,
    faCogs,
    faCog,
    faSearch,
    faTrash,
    faExclamationTriangle,
    faExclamationCircle,
    faCheck,
    faCheckCircle,
    faXmarkCircle,
    faMinusCircle,
    faTimes,
    faNotesMedical,
    faCalendarMinus,
    faThumbsDown,
    faExclamation,
    faQrcode,
    faPencilAlt,
    faStickyNote,
    faFileCircleCheck,
    faFileDownload,
    faFileExport,
    faFilePdf,
    faFile,
    faUser,
    faPhone,
    faEnvelope,
    faArrowUpRightFromSquare,
    faBook,
    faFileExcel,
    faCircleQuestion,
    faPlayCircle,
    faPrint,
    faPaperclip,
    faBars,
    faCaretDown,
    faComment,
    faTruck
  );
};
